<template>
  <div class="group-listing tour-listing">
    <div
      class="v-map-view--icon"
      style="z-index: 1;"
      :style="rightDrawer.opened ? 'margin-right: 490px' : ''"
    >
      <v-icon
        class="show-map-icon d-none"
        @click="currentView = 'tour-map'"
        v-if="currentView === 'list'"
        title="Show in map"
      >
        $map
      </v-icon>
      <v-icon
        @click="currentView = 'list'"
        dark
        v-else
        title="Show in table"
        class="show-map-icon-n"
      >
        $viewGrid
      </v-icon>
    </div>
    <div
      class="show-tourmap-icon d-block d-md-none"
      style="z-index: 1;"
      :style="rightDrawer.opened ? 'margin-right: 490px' : ''"
    >
      <v-icon
        class="show-map-icon"
        @click="currentView = 'tour-map'"
        v-if="currentView === 'list'"
        title="Show in map"
      >
        $map
      </v-icon>
      <v-icon
        @click="currentView = 'list'"
        dark
        v-else
        title="Show in table"
        class="show-map-icon-n"
      >
        $viewGrid
      </v-icon>
    </div>
    <component
      :is="currentView"
      :tours.sync="tours"
      :model="model"
      @fetch="fetchData"
      :total="total"
      @newTour="newTour"
      @edit="edit"
      :createMode="createMode"
    />
    <drawer
      @close="secondaryDrawer = ''"
      v-if="createMode && secondaryDrawer"
      :value="true"
      mr="600px"
      class="secondary-drawer--light"
      color="#F5F7FB"
      v-bind="secondaryDrawer === 'Stat' ? { width: 600 } : {}"
    >
      <template v-slot:child>
        <component
          :is="secondaryDrawer"
          @exit="speciesSelected"
          id="SubAsideWrapper"
          :isDrawer="true"
          v-bind="
            secondaryDrawer === 'Stat'
              ? { species: selectedSpecies }
              : { request }
          "
        />
      </template>
    </drawer>

    <drawer @close="crudDone" v-model="createMode" width="600px">
      <template v-slot:child>
        <validation-observer ref="validator">
          <Create
            ref="crud"
            @showStat="showStat"
            @addSpecies="addSpecies"
            @exit="crudDone"
            v-if="createMode"
            id="AsideWrapper"
            :isDrawer="true"
            :request="request"
            :types="types"
            :projects="projects"
          />
        </validation-observer>
      </template>
      <template v-slot:append>
        <div>
          <div class="px-md-24 pt-md-12 mt-8 mt-md-0 mx-5 mx-md-0">
            <v-btn
              block
              dark
              large
              class="black justify-space-between justify-md-center"
              @click="toggleSpeciesSelection()"
            >
              {{
                secondaryDrawer === 'SelectSpecies' ? 'Finish' : 'Add Species'
              }}
              <v-icon v-if="secondaryDrawer !== 'SelectSpecies'" right ml-5>
                $plus
              </v-icon>
            </v-btn>
          </div>
          <div
            class="px-md-24 py-md-12 my-5 mx-5 mx-md-0 d-flex flex-column flex-md-row justify-lg-space-between"
          >
            <v-btn
              large
              class="white px-14 mb-3 mb-md-0"
              min-width="45%"
              @click="crudDone()"
            >
              Cancel
            </v-btn>
            <v-btn
              :loading="request.submitting"
              :disabled="request.submitting"
              min-width="45%"
              large
              class="primary px-14"
              @click="submit()"
            >
              Submit
            </v-btn>
          </div>
        </div>
      </template>
    </drawer>
  </div>
</template>

<script>
import Model from '@models/Tour';
import TourRequest from '@request/TourRequest';
import ProjectRequest from '@request/ProjectRequest';

export default {
  name: 'Tours',
  metaInfo: {
    titleTemplate: '%s - Tours',
  },
  components: {
    SelectSpecies: () => import('./_partials/SelectSpecies'),
    Drawer: () => import('@layouts/_partials/Drawer'),
    List: () => import('./_partials/ToursList'),
    TourMap: () => import('./_partials/ToursMap'),
    Create: () => import('./Create'),
    Stat: () => import('@pages/species/_paritials/SpeciesStatistics'),
  },
  data() {
    return {
      secondaryDrawer: '',
      request: new TourRequest(this.$refs, {
        species: [],
        species_ids: [],
      }),
      projectRequest: new ProjectRequest(this.$refs),
      types: [],
      projects: [],
      currentView: this.$route.query.view === 'list' ? 'list' : 'tour-map',
      createMode: false,
      selectedTour: null,
      selectedSpecies: null,
      tours: [],
      model: new Model({
        relations: ['type', 'species', 'species.family', 'projects'],
      }),
      total: 0,
    };
  },
  methods: {
    crudDone(tour) {
      if (!tour) {
        this.createMode = false;
        this.secondaryDrawer = '';
        return;
      }
      if (
        this.selectedTour &&
        parseInt(tour.id) === parseInt(this.selectedTour.id)
      ) {
        this.selectedTour = Object.assign(this.selectedTour, tour);
      } else {
        this.tours.push(tour);
      }
      this.createMode = false;
      this.secondaryDrawer = '';
    },
    async fetchData() {
      let response = await this.model.get();
      if (response) {
        this.tours = response.data;
        this.total = response.pagination.total;
      }
    },
    edit(tour) {
      if (!this.types.length) {
        this.fetchTourTypes();
      }
      if (!this.projects.length) {
        this.fetchProjects({
          tourism_operator_id: this.currentUser.id,
        });
      }
      this.selectedTour = null;
      this.createMode = false;
      this.selectedTour = tour;
      this.request.reinit(tour);
      this.createMode = true;
    },
    newTour() {
      if (!this.types.length) {
        this.fetchTourTypes();
      }
      if (!this.projects.length) {
        this.fetchProjects({
          tourist_operator_id: this.currentUser.id,
        });
      }
      this.selectedTour = null;
      this.request.reset({
        species: [],
        species_ids: [],
      });
      this.createMode = !this.createMode;
    },
    async addSpecies() {
      if (this.secondaryDrawer) {
        this.secondaryDrawer = '';
        await this.$nextTick();
      }
      this.secondaryDrawer = 'SelectSpecies';
    },
    async showStat(species) {
      this.selectedSpecies = {};
      if (this.secondaryDrawer) {
        this.secondaryDrawer = '';
      }
      await this.$nextTick();

      Object.assign(this.selectedSpecies, species);
      this.secondaryDrawer = 'Stat';
    },
    toggleSpeciesSelection() {
      if (this.secondaryDrawer === 'SelectSpecies') {
        this.secondaryDrawer = '';
      } else {
        this.addSpecies();
      }
    },
    speciesSelected() {
      this.secondaryDrawer = '';
    },
    async fetchTourTypes() {
      let response = await this.request.model.getTypes();
      if (response) {
        this.types = response.data;
      }
    },
    async fetchProjects(params = {}) {
      let response = await this.projectRequest.model.getMinimal(params);
      if (response) {
        this.projects = response.data;
      }
    },
    async submit() {
      if (await this.$refs.validator.validate()) {
        if (!this.request.id) {
          if (this.request.species_ids.length === 0) {
            $showInfo('Must add at least one species');
            return;
          }
        }

        let response = await this.request.submit();
        if (response) {
          response.data.type = this.types.find(
            (type) => type.id === response.data.type_id
          );
          this.crudDone({ ...response.data, species: this.request.species });
        }
      }
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>

<style lang="scss">
.map-toolbar {
  right: 60px !important;
}

.map-layout {
  .map-toolbar {
    right: 0 !important;
  }
}

.v-map-view--icon {
  position: fixed;
  z-index: 9;
  right: 16px;
  top: 60px;

  .v-icon {
    &:focus {
      outline: 0 none;
    }
  }

  &:focus {
    outline: 0 none;
  }
}
</style>
